// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@insite/mobius/LazyImage";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { myAccountViewStyles } from "@rpsc/Overrides/Widgets/MyAccount/MyAccountView";
import { styledBox } from "@rpsc/XDL/Components/Common/Box";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 317px) minmax(0, 1fr);
        grid-column-gap: 22px;
        width: 100%;
        background: ${color("common.white")};
        ${xScreen("gte", "xl")} {
            grid-template-columns: minmax(0, 376px) minmax(0, 1fr);
        }
        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 232px) minmax(0, 1fr);
            grid-column-gap: 20px;
        }
    `,
};

myAccountViewStyles.navigationList = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 7;
        display: flex;
        flex-direction: column;
        gap: 24px;
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 3;
            grid-row: 1 / 2;
            margin-bottom: 32px;
        }
    `,
};

myAccountViewStyles.extraCardsWrapper = {
    css: css`
        & > div:first-child {
            display: flex;
            flex-direction: column;
            gap: 24px;
            ${xScreen("lte", "md")} {
                ${LazyImageStyle} {
                    height: 200px;
                }
            }
        }
    `,
};

myAccountViewStyles.pageTitle = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 3;
            grid-row: 2 / 3;
        }
    `,
};

myAccountViewStyles.welcomeSection = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 2 / 3;
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 3;
            grid-row: 3 / 4;
        }
    `,
};

myAccountViewStyles.messageWrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
        padding-bottom: 10px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 16px;
        row-gap: 12px;
        flex-wrap: wrap;
        > div {
            width: auto;
        }
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
        & > div:first-child {
            flex: 1 1 auto;
            ${TypographyStyle} {
                font-size: 20px;
                line-height: 28px;
            }
            .customer-wrapper{
                flex-wrap: wrap;
            }
            .customer-number {
                font-size: 16px;
                line-height: 22px;
            }
        }
    `,
};

myAccountViewStyles.quickOrderSection = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 3 / 4;
        padding-bottom: 32px;
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 3;
            grid-row: 4 / 5;
        }
    `,
};

myAccountViewStyles.dashboardWidgets = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 4/ 5;
        > div {
            display: flex;
            flex-direction: column;
            gap: 32px;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 3;
            grid-row: 5 / 6;
        }
    `,
};
